/* tslint:disable */
/* eslint-disable */
/**
 * Navitia API - SNCF
 * Complete API documentation for Navitia/SNCF public transportation API. Based on https://doc.navitia.io
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '@/client/configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '@/client/common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '@/client/base';
// @ts-ignore
import type { ArrivalsResponse } from '@/client/models';
/**
 * ArrivalsApi - axios parameter creator
 */
export const ArrivalsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get next arrivals to a stop area
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} id 
         * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
         * @param {number} [count] Number of results to return
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageStopAreasIdArrivalsGet: async (coverage: string, id: string, datetime?: string, count?: number, depth?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageStopAreasIdArrivalsGet', 'coverage', coverage)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('coverageCoverageStopAreasIdArrivalsGet', 'id', id)
            const localVarPath = `/coverage/{coverage}/stop_areas/{id}/arrivals`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (datetime !== undefined) {
                localVarQueryParameter['datetime'] = datetime;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            if (depth !== undefined) {
                localVarQueryParameter['depth'] = depth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArrivalsApi - functional programming interface
 */
export const ArrivalsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArrivalsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get next arrivals to a stop area
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} id 
         * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
         * @param {number} [count] Number of results to return
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageStopAreasIdArrivalsGet(coverage: string, id: string, datetime?: string, count?: number, depth?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArrivalsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageStopAreasIdArrivalsGet(coverage, id, datetime, count, depth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArrivalsApi.coverageCoverageStopAreasIdArrivalsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ArrivalsApi - factory interface
 */
export const ArrivalsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArrivalsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get next arrivals to a stop area
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} id 
         * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
         * @param {number} [count] Number of results to return
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageStopAreasIdArrivalsGet(coverage: string, id: string, datetime?: string, count?: number, depth?: number, options?: RawAxiosRequestConfig): AxiosPromise<ArrivalsResponse> {
            return localVarFp.coverageCoverageStopAreasIdArrivalsGet(coverage, id, datetime, count, depth, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ArrivalsApi - interface
 */
export interface ArrivalsApiInterface {
    /**
     * 
     * @summary Get next arrivals to a stop area
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} id 
     * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
     * @param {number} [count] Number of results to return
     * @param {number} [depth] Depth of detail in response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageStopAreasIdArrivalsGet(coverage: string, id: string, datetime?: string, count?: number, depth?: number, options?: RawAxiosRequestConfig): AxiosPromise<ArrivalsResponse>;

}

/**
 * ArrivalsApi - object-oriented interface
 */
export class ArrivalsApi extends BaseAPI implements ArrivalsApiInterface {
    /**
     * 
     * @summary Get next arrivals to a stop area
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} id 
     * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
     * @param {number} [count] Number of results to return
     * @param {number} [depth] Depth of detail in response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageStopAreasIdArrivalsGet(coverage: string, id: string, datetime?: string, count?: number, depth?: number, options?: RawAxiosRequestConfig) {
        return ArrivalsApiFp(this.configuration).coverageCoverageStopAreasIdArrivalsGet(coverage, id, datetime, count, depth, options).then((request) => request(this.axios, this.basePath));
    }
}

